import { render, staticRenderFns } from "./Categorias.vue?vue&type=template&id=73927536&scoped=true"
import script from "./Categorias.vue?vue&type=script&lang=js"
export * from "./Categorias.vue?vue&type=script&lang=js"
import style0 from "./Categorias.vue?vue&type=style&index=0&id=73927536&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73927536",
  null
  
)

export default component.exports